import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { DragulaModule, DragulaService } from "ng2-dragula";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject, Subscription } from "rxjs";

@Component({
    selector: "app-reorder-options-modal",
    imports: [CommonModule, DragulaModule],
    templateUrl: "./reorder-options-modal.component.html",
    styleUrl: "./reorder-options-modal.component.scss"
})
export class ReorderOptionsModalComponent implements OnInit {
  subs = new Subscription();
  @Input() options;

  constructor(
    public bsModalRef: BsModalRef,
    private dragulaService: DragulaService
  ) {}

  ngOnInit(): void {
    this.subs.add(this.dragulaService.dropModel("OPTIONS").subscribe());
    this.onClose = new Subject();
  }

  public onClose: Subject<boolean>;

  confirm() {
    this.bsModalRef.hide();
    this.onClose.next(this.options);
  }

  cancel() {
    this.bsModalRef.hide();
    this.onClose.next(false);
  }
}
